module.exports = __webpack_public_path__ + "img/team-4.8116b8d5.png";